// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.licenza-modulo-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) 3.25rem;
  align-items: center;
  margin-bottom: 8px;
  border: 1px solid var(--ion-color-step-150);
  border-radius: 10px;
  overflow: hidden;
  background: var(--ion-card-background);
  cursor: pointer;
  transition: background-color 160ms ease;
}

.licenza-modulo-row:hover {
  background: var(--ion-color-step-200);
}

.licenza-modulo-attivazione {
  grid-column: 3;
  grid-row: 1/4;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  border-left: 1px solid var(--ion-color-step-150);
}

.licenza-modulo-livello {
  grid-column: 1;
  grid-row: 1;
  padding: 10px 0 4px 12px;
}

.licenza-modulo-livello ion-badge {
  display: block;
  text-align: center;
}

.licenza-modulo-codice {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 10px 12px 4px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.licenza-modulo-commerciale {
  grid-column: 1/3;
  grid-row: 2;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 0 12px 4px;
  overflow-wrap: anywhere;
}

.licenza-modulo-descrizione {
  grid-column: 1/3;
  grid-row: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 0 12px 10px;
  overflow-wrap: anywhere;
}

.licenza-modulo-mobile-label {
  flex: none;
  color: var(--ion-color-medium);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.licenza-modulo-voci {
  margin-top: 4px;
  color: var(--ion-color-medium);
  font-size: 12px;
}

@media (min-width: 768px) {
  .licenza-modulo-row {
    grid-template-columns: var(--licenze-grid-columns);
    align-items: stretch;
    margin-bottom: 4px;
    border: 0;
    border-radius: 8px;
  }
  .licenza-modulo-row > div {
    grid-row: 1;
    padding: 8px 10px;
    border: 1px solid var(--ion-color-step-150);
  }
  .licenza-modulo-attivazione {
    grid-column: 1;
  }
  .licenza-modulo-livello {
    grid-column: 2;
    display: flex;
    align-items: center;
  }
  .licenza-modulo-livello ion-badge {
    width: 100%;
  }
  .licenza-modulo-codice {
    grid-column: 3;
  }
  .licenza-modulo-commerciale {
    grid-column: 4;
  }
  .licenza-modulo-descrizione {
    grid-column: 5;
  }
  .licenza-modulo-mobile-label {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/licenze/licenze-config-item/licenze-config-item.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;AADF;;AAQA;EACE,aAAA;EACA,kDAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,uCAAA;AALF;;AAQA;EACE,qCAAA;AALF;;AAUA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gDAAA;AAPF;;AAUA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;AAPF;;AAUA;EACE,cAAA;EACA,kBAAA;AAPF;;AAUA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,UAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,eAAA;EACA,8BAAA;EACA,eAAA;AAPF;;AAUA;EAIE;IACE,kDAAA;IACA,oBAAA;IACA,kBAAA;IACA,SAAA;IACA,kBAAA;EAVF;EAcA;IACE,WAAA;IACA,iBAAA;IACA,2CAAA;EAZF;EAeA;IACE,cAAA;EAbF;EAgBA;IACE,cAAA;IACA,aAAA;IACA,mBAAA;EAdF;EAkBA;IACE,WAAA;EAhBF;EAmBA;IACE,cAAA;EAjBF;EAoBA;IACE,cAAA;EAlBF;EAqBA;IACE,cAAA;EAnBF;EAsBA;IACE,aAAA;EApBF;AACF","sourcesContent":["// Il componente è ricorsivo (i sottomoduli sono altre istanze di se stesso): senza display:block\n// l'host resta inline e le righe annidate non occupano la larghezza piena.\n:host {\n  display: block;\n}\n\n// Mobile-first, come .organizzazione-row in organizzazioni-home.component.scss: di base la riga è\n// una scheda a sé (bordo, angoli, sfondo proprio), e solo da 768px in su le stesse celle si\n// allineano alle colonne dell'intestazione. Lo sfondo \"interno\" della riga è quello richiesto in\n// precedenza: resta var(--ion-card-background) a entrambi i breakpoint.\n.licenza-modulo-row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) 3.25rem;\n  align-items: center;\n  margin-bottom: 8px;\n  border: 1px solid var(--ion-color-step-150);\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--ion-card-background);\n  cursor: pointer;\n  transition: background-color 160ms ease;\n}\n\n.licenza-modulo-row:hover {\n  background: var(--ion-color-step-200);\n}\n\n// Fascia laterale a tutta altezza su mobile: la chiave è l'unico comando della riga (il tap attiva\n// o disattiva il modulo), quindi resta sempre nello stesso punto invece di scorrere col testo.\n.licenza-modulo-attivazione {\n  grid-column: 3;\n  grid-row: 1 / 4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  border-left: 1px solid var(--ion-color-step-150);\n}\n\n.licenza-modulo-livello {\n  grid-column: 1;\n  grid-row: 1;\n  padding: 10px 0 4px 12px;\n}\n\n.licenza-modulo-livello ion-badge {\n  display: block;\n  text-align: center;\n}\n\n.licenza-modulo-codice {\n  grid-column: 2;\n  grid-row: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  padding: 10px 12px 4px;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.licenza-modulo-commerciale {\n  grid-column: 1 / 3;\n  grid-row: 2;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  padding: 0 12px 4px;\n  overflow-wrap: anywhere;\n}\n\n.licenza-modulo-descrizione {\n  grid-column: 1 / 3;\n  grid-row: 3;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  padding: 0 12px 10px;\n  overflow-wrap: anywhere;\n}\n\n.licenza-modulo-mobile-label {\n  flex: none;\n  color: var(--ion-color-medium);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.licenza-modulo-voci {\n  margin-top: 4px;\n  color: var(--ion-color-medium);\n  font-size: 12px;\n}\n\n@media (min-width: 768px) {\n  // Le colonne arrivano da licenze-config.component.scss tramite variabile CSS: le custom property\n  // attraversano l'incapsulamento dei componenti, così intestazione e righe restano allineate\n  // essendo dichiarate una sola volta.\n  .licenza-modulo-row {\n    grid-template-columns: var(--licenze-grid-columns);\n    align-items: stretch;\n    margin-bottom: 4px;\n    border: 0;\n    border-radius: 8px;\n  }\n\n  // Bordo per cella: riproduce l'aspetto a griglia già approvato sul desktop.\n  .licenza-modulo-row > div {\n    grid-row: 1;\n    padding: 8px 10px;\n    border: 1px solid var(--ion-color-step-150);\n  }\n\n  .licenza-modulo-attivazione {\n    grid-column: 1;\n  }\n\n  .licenza-modulo-livello {\n    grid-column: 2;\n    display: flex;\n    align-items: center;\n  }\n\n  // Larghezza piena: il badge occupa tutta la colonna, così \"1\" e \"10.1\" hanno la stessa misura.\n  .licenza-modulo-livello ion-badge {\n    width: 100%;\n  }\n\n  .licenza-modulo-codice {\n    grid-column: 3;\n  }\n\n  .licenza-modulo-commerciale {\n    grid-column: 4;\n  }\n\n  .licenza-modulo-descrizione {\n    grid-column: 5;\n  }\n\n  .licenza-modulo-mobile-label {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
